import { useState } from 'react';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../ui/Button';
import { Field } from '../ui/Field';
import { supabase } from './supabase-client';

export function UpdatePasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function updatePassword(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!supabase) return;
    setPending(true);
    setError(null);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    if (updateError) {
      setError('Le mot de passe n’a pas pu être mis à jour.');
      setPending(false);
      return;
    }
    void navigate('/');
  }

  return (
    <main className="auth-page">
      <section className="auth-story" aria-label="Présentation ALBA">
        <div>
          <p className="eyebrow">ALBA</p>
          <h2>Une tâche, un tap, une décision.</h2>
        </div>
      </section>
      <section className="auth-card" aria-labelledby="update-title">
        <p className="eyebrow">ALBA</p>
        <h1 id="update-title">Nouveau mot de passe</h1>
        <form onSubmit={(event) => void updatePassword(event)} className="auth-form">
          <Field
            label="Nouveau mot de passe"
            type="password"
            autoComplete="new-password"
            minLength={12}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <Button type="submit" disabled={pending}>
            {pending ? 'Mise à jour' : 'Valider'}
          </Button>
        </form>
        {error && (
          <p className="error-state" role="alert">
            {error}
          </p>
        )}
      </section>
    </main>
  );
}
